import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const EnquiriesInbox = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/enquiries")
      .then((r) => setEnquiries(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="mt-14" data-testid="enquiries-inbox">
      <h2 className="font-serif text-2xl font-semibold text-navy mb-6">Contact Enquiries</h2>

      {loading ? (
        <p className="font-mono text-xs text-navy/40 tracking-widest">LOADING…</p>
      ) : enquiries.length === 0 ? (
        <div className="bg-white border border-navy/10 p-10 text-center" data-testid="enquiries-empty">
          <p className="text-sm text-navy/50">No enquiries yet.</p>
        </div>
      ) : (
        <div className="space-y-4" data-testid="enquiries-list">
          {enquiries.map((q) => (
            <div key={q.id} className="bg-white border border-navy/10 p-6" data-testid={`enquiry-${q.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                <div>
                  <p className="font-serif text-lg font-semibold text-navy">{q.name}</p>
                  <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-gold mt-1">
                    {q.enquiry_type}
                  </p>
                </div>
                <p className="font-mono text-[10px] text-navy/40">
                  {new Date(q.created_at).toLocaleDateString("en-GB")}
                </p>
              </div>
              <p className="text-xs text-navy/50 mb-3">
                {q.email}
                {q.organization ? ` · ${q.organization}` : ""}
                {q.role ? ` · ${q.role}` : ""}
                {q.phone ? ` · ${q.phone}` : ""}
              </p>
              <p className="text-sm text-navy/70 leading-relaxed border-l-2 border-gold/50 pl-4">
                {q.message}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
